<template>
	<div>
    <!--  v-on:submit.prevent="updateClientConfigurationSiteSettings" -->
		<!-- <form id="formSiteSetupPaymentConfig" class="d-flex flex-column"> -->
      <div class="d-flex flex-column tab-card-form">
        <div class="element-info">
          <div class="row align-items-center">
            <div class="col-sm-8">
              <div class="element-info-with-icon">
                <div class="element-info-icon">
                  <fontAwesomeIcon :icon="['fas', 'money-check']" size="2x" />
                </div>
                <div class="element-info-text ml-5">
                  <h5 class="element-inner-header">Payment Configuration</h5>
                  <div class="element-inner-desc">Here you can change the payment configurations.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-box d-flex flex-column">
          <div class="project-head">
            <div class="project-title">
              <h5 class="py-2 element-header">Payment Methods</h5>
            </div>
          </div>
					<div class="row" v-if="paymentMethods">
						<b-form-group class="mt-3 col-lg-6 col-sm-12">
							<b-input-group>
								<b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                  <b-input-group-text slot="prepend" class="col-12 pretext">
                    <span class="pretext-span">Select Payment Method</span>
                  </b-input-group-text>
								</b-input-group-prepend>
								<select class="form-control" v-model="selectedPaymentMethod" @change="getPaymentConfiguration()">
                  <option value="">Select Payment Method</option>
                  <option v-for="paymentMethod in paymentMethods" :value="paymentMethod.id" :key="paymentMethod.id">{{ paymentMethod.name }}</option> 
								</select>
                <button class="btn btn-primary ml-2" v-if="selectedPaymentMethod" @click="openPaymentConfigModal()">Add Configuration</button>
							</b-input-group>
						</b-form-group>
					</div>
          <div class="row">
            <div v-if="selectedPaymentMethod && getPaymentDocumentTypes" class="col-6">
              <multiselect v-model="selectedUserDocTypes" placeholder="Enable Payment for Selected Document Types" :options="getPaymentDocumentTypes" :multiple="true" label="name" track-by="id" :close-on-select="true" :clear-on-select="false" :taggable="true">
              </multiselect>
            </div>
            <div class="col-12 pl-0" v-if="selectedPaymentMethod && paymentConfiguration">
              <div v-for="paymentConfig in paymentConfiguration" :key="paymentConfig.id">
                <b-form-group v-if="paymentConfig.config_key != 'assignedDocTypes'" class="mt-3 col-lg-6 col-sm-12">
                  <b-input-group>
                    <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                      <b-input-group-text slot="prepend" class="col-12 pretext">
                        <span class="pretext-span">{{ paymentConfig.config_key }}</span>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input v-model="paymentConfig.config_value" type="text"></b-form-input>
                    <a href="javascript:;" class="btn btn-danger ml-2 flex-align" @click="deletePaymentConfigurationModal(paymentConfig.id, paymentConfig.config_key)">Delete</a>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="col-12 px-0" v-if="missingConditions && paymentConfiguration">
            <p class="text-danger font-weight-bold" v-if="!missingConditions.isEnabled">Missing "is_enabled" configuration for this payment!</p>
            <p class="text-danger font-weight-bold" v-if="!missingConditions.paymentCurrency">Missing "payment_currency" configuration for this payment!</p>
            <p class="text-danger font-weight-bold" v-if="!missingConditions.currencySymbol">Missing "currency_symbol" configuration for this payment!</p>
          </div>
          <div class="row">
            <ResponseInfo v-if="getResponseInfo.responseName == 'paymentConfiguration'" class="mt-3"/>
          </div>
          <div class="row mx-0" v-if="selectedPaymentMethod && paymentConfiguration">
            <button class="btn btn-primary" @click="updatePaymentConfiguration()">Update</button>
          </div>
        </div>
      </div>
    <!-- </form> -->
    <ModalPaymentConfiguration :paymentMethod="selectedPaymentMethod" />
    <ModalConfigurationDeleteConfirmation :configId="configId" :configKey="configKey" />
    <div class="modal-backdrop show" v-if="overlayActive"></div>
	</div>
</template>

<script>
import ResponseInfo from '@/components/ResponseInfo.vue'
import ModalPaymentConfiguration from '@/components/Site_setup/ModalPaymentConfiguration.vue'
import ModalConfigurationDeleteConfirmation from '@/components/Site_setup/ModalConfigurationDeleteConfirmation.vue'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
	name: 'SiteSetupPaymentConfiguration',
	data() {
		return {
      paymentMethods: null,
      selectedPaymentMethod: '',
      paymentConfiguration: null,
      overlayActive: false,
      userDocTypes: [],
      selectedUserDocTypes: null,
      configId: null,
      configKey: null,
      missingConditions: {
        isEnabled: false,
        paymentCurrency: false,
        currencySymbol: false
      }
		}
	},
	methods: {
    checkMissingPaymentConditions() {
      if(this.paymentConfiguration) {
        let config = this.paymentConfiguration
        let self = this
        config.some(function(el) {
           if(el.config_key === 'is_enabled') {
             self.missingConditions.isEnabled = true
           };

           if(el.config_key === 'payment_currency') {
             self.missingConditions.paymentCurrency = true
           }

           if(el.config_key === 'currency_symbol') {
             self.missingConditions.currencySymbol = true
           }
        }); 
      }
    },

    getPaymentMethods() {
      this.$store.dispatch('onlinePaymentStore/getPaymentMethods').then(response => {
        if(response.paymentMethods) {
          this.paymentMethods = response.paymentMethods
        }
      })
    },
    getPaymentConfiguration() {
      this.$store.dispatch('onlinePaymentStore/getPaymentConfiguration', 
      {
        id: this.selectedPaymentMethod
      }).then(response => {
        if(response.paymentConfiguration) {
          this.paymentConfiguration = response.paymentConfiguration
          let self = this

          response.paymentConfiguration.forEach( function(el) {
            if(el.config_key == 'assignedDocTypes') {
              self.selectedUserDocTypes = el.config_value
            }
          })

          this.checkMissingPaymentConditions()
        }
      })
    },

    openPaymentConfigModal() {
      this.overlayActive = true
      this.$root.$emit('bv::show::modal', 'createPaymentConfig')
    },

    deletePaymentConfigurationModal(id, key) {
      this.overlayActive = true
      this.configId = id
      this.configKey = key
      this.$root.$emit('bv::show::modal', 'confirmDeletionConfirm')
    },

    deleteConfiguration(configId) {
      this.overlayActive = false
      this.$root.$emit('bv::hide::modal', 'confirmDeletionConfirm')
      this.$store.dispatch('onlinePaymentStore/deletePaymentConfiguration', 
      {
        id: configId
      }).then(response => {
        if(response.status && response.status == 'success') {
          this.getPaymentConfiguration()
          this.checkMissingPaymentConditions()
        }
      })
    }, 

    getDocTypesList() {
      this.$store.dispatch('onlinePaymentStore/getPaymentDocumentTypes')
    },

    updatePaymentConfiguration() {
      this.$store.dispatch('onlinePaymentStore/updatePaymentConfiguration', {
        paymentMethodId: this.selectedPaymentMethod,
        configuration: this.paymentConfiguration,
        userDocTypes: this.selectedUserDocTypes
      }).then(response => {
        this.getPaymentConfiguration()
        this.checkMissingPaymentConditions()
      })
    },

    closeModal() {
      this.overlayActive = false
      this.$root.$emit('bv::hide::modal', 'createPaymentConfig')
      this.getPaymentConfiguration()
    }
	},
	created() {
    this.getPaymentMethods()
    this.getDocTypesList()
	},
	computed: {
    ...mapGetters('onlinePaymentStore', ['getPaymentDocumentTypes']),
    ...mapGetters(['getResponseInfo'])	
  },
  components: {
    ModalPaymentConfiguration,
    ModalConfigurationDeleteConfirmation,
    Multiselect,
    ResponseInfo
  }
}

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.flex-align {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>